import type { IUserInfoRes } from '@/api/types/login'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import {
  getUserInfo,
} from '@/api/login'

// 初始化状态
const userInfoState: IUserInfoRes = {
  userId: -1,
  username: '',
  nickname: '',
  avatar: '/static/images/default-avatar.png',
}

export const useUserStore = defineStore(
  'user',
  () => {
    // 定义用户信息
    const userInfo = ref<IUserInfoRes>({ ...userInfoState })
    const token = ref<string>(uni.getStorageSync('token') || '')
    const phoneNum = ref<string>(uni.getStorageSync('phoneNumber') || '')
    const isLogin = computed(() => Boolean(token.value || uni.getStorageSync('token')))
    const isPhoneNum = computed(() => Boolean(phoneNum.value || uni.getStorageSync('phoneNumber')))

    const setLogin = (val: boolean | string) => {
      if (typeof val === 'string') {
        token.value = val
        return
      }
      token.value = val ? (uni.getStorageSync('token') || '1') : ''
    }

    const setPhoneNum = (val: string) => {
      phoneNum.value = val || ''
    }

    // 设置用户信息
    const setUserInfo = (val: IUserInfoRes) => {
      console.log('设置用户信息', val)
      // 若头像为空 则使用默认头像
      if (!val.avatar) {
        val.avatar = userInfoState.avatar
      }
      userInfo.value = val
    }
    const setUserAvatar = (avatar: string) => {
      userInfo.value.avatar = avatar
      console.log('设置用户头像', avatar)
      console.log('userInfo', userInfo.value)
    }
    // 删除用户信息
    const clearUserInfo = () => {
      userInfo.value = { ...userInfoState }
      uni.removeStorageSync('user')
    }

    /**
     * 获取用户信息
     */
    const fetchUserInfo = async () => {
      const res = await getUserInfo()
      setUserInfo(res)
      return res
    }

    return {
      userInfo,
      isLogin,
      isPhoneNum,
      clearUserInfo,
      fetchUserInfo,
      setLogin,
      setPhoneNum,
      setUserInfo,
      setUserAvatar,
    }
  },
  {
    persist: true,
  },
)
